export const MOVING_HOME_FLOW = {
  SmartSearchBuyingProcessStage: 0,
  SmartSearchBasicDetails: 1,
  SmartSearchInitialRate: 2,
  SmartSearchLiveResults: 3,
  PropertyAddress: 4,
  PropertyOverview: 5,
  PropertyAdditionalInfo: 6,
  MortgageLender: 7,
  MortgageRateAndPeriod: 8,
  MortgageBorrowedAmountAndTerm: 9,
  MortgageMonthlyPayment: 10,
  MortgageProductMatch: 11,
  UserCreate: 12,
} as const;
